// Intervalo de consulta en vivo (R12, propuesta 2026-10-alimentos-rionegro).
//
// La fábrica manda un conteo cada 10 s y el API ya calcula en vivo el KPI de
// las líneas conectadas (vw_kpis_linea_turno_rt, mig 098). Para que la cantidad
// se vea en 10–20 s, las superficies que muestran líneas conectadas consultan
// más seguido. Líneas manuales y tenants sin líneas conectadas conservan los
// 30 s de siempre: no hay dato nuevo que ver antes.

export const INTERVALO_NORMAL_MS = 30_000;
const INTERVALO_CAPTURA_VIVO_MS = 10_000;
const INTERVALO_PANTALLA_VIVO_MS = 10_000;
const INTERVALO_SUPERVISOR_VIVO_MS = 15_000;

/** Línea alimentada por la ingesta de máquina (híbrida o solo máquina). */
export function esFuenteConectada(fuente: string | null | undefined): boolean {
  return fuente === 'hibrida' || fuente === 'maquina';
}

/** Página de captura del líder: 10 s si su línea está conectada. */
export function intervaloCaptura(fuente: string | null | undefined): number {
  return esFuenteConectada(fuente) ? INTERVALO_CAPTURA_VIVO_MS : INTERVALO_NORMAL_MS;
}

type ConLineasMaquina = { tiene_lineas_maquina?: boolean } | undefined;

/** TV de planta: 10 s si la planta tiene al menos una línea conectada. */
export function intervaloPantalla(datos: ConLineasMaquina): number {
  return datos?.tiene_lineas_maquina === true ? INTERVALO_PANTALLA_VIVO_MS : INTERVALO_NORMAL_MS;
}

/** Dashboard S1 del supervisor: 15 s si alguna línea del scope está conectada. */
export function intervaloSupervisor(datos: ConLineasMaquina): number {
  return datos?.tiene_lineas_maquina === true ? INTERVALO_SUPERVISOR_VIVO_MS : INTERVALO_NORMAL_MS;
}
